import currency from "currency.js";
import { useStoreState } from "easy-peasy";
import { useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";
import { qtyFormat, qtyFormatToString } from "../../utils/helpers";

export default function ConvertQuantity({
  quantity = 0,
  desc = "",
  convertNow,
}) {
  const { isIronRod } = useAuth();
  const generalSettings = useStoreState((state) => state?.generalSettings);
  const itemMeasurements = useStoreState((state) => state.itemMeasurements);

  return (
    <>
      {(isIronRod && generalSettings?.convertToTonsAndPcs) || convertNow
        ? qtyFormatToString(
            qtyFormat(quantity, desc, itemMeasurements),
            false,
            generalSettings.convertableUOM
          )
        : currency(quantity, {
            symbol: "",
            precision: 1,
          })
            .format()
            .toString()
            .replace(".0", "")}
    </>
  );
}
